<template>
  <div class="left-slider">
    <slot name="header"></slot>
    <template v-if="type == 'navigation'"></template>
    <div v-for="(item, index) in list" :key="index" class="list-items flex pointer flex_items" @click="pageTo(item)"
      :class="[check == item.id ? 'main_color' : '',item.show || item.isShow ? '' : 'none',
      selfCheckType && selfCheckType == 4 && item.id == 5 ? 'none' : '']">
      <img :src="item.checkIcon" alt="" class="icon" v-if="check == item.id">
      <img :src="item.icon" alt="" class="icon" v-else>
      {{ item.name }}
    </div>
    <slot name="content"></slot>
    <slot name="footer"></slot>
  </div>
</template>
<script>
export default {
  props: {
    list: [],
    type: { //侧边栏的样式 navigation-icon+文字的导航
      default: 'navigation'
    },
    check: 0,
    query:{
      default:() => { return {}}
    },
    selfCheckType:'',//自检的type 次检没有特殊填报
  },
  methods: {
    pageTo(item) {
      this.$router.push({path:item.path,query:this.query})
    }
  }
}
</script>
<style scoped>
.left-slider {
  position: absolute;
  height: calc(100vh - 125px);
  z-index: 0;
  background: #fff;
  width: 288px;
  padding: 24px 0 0 32px;
  overflow-y: auto;
}

.icon {
  width: 20px;
  height: 20px;
  display: block;
  margin-right: 20px;
}

.list-items {
  height: 40px;
  margin-bottom: 26px;
}

.none{
  display: none;
}
</style>